import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { auth } from "@/lib/api";
import { loadFeatures } from "@/lib/features";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try { setUser(await auth.me()); } catch { setUser(null); }
    setLoading(false);
  }, []);

  useEffect(() => {
    loadFeatures(); // central feature-control state (safe defaults if it fails)
    // CRITICAL: skip /me while returning from OAuth callback (AuthCallback handles it).
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refresh();
  }, [refresh]);

  const logout = async () => { try { await auth.logout(); } catch {} setUser(null); };

  return <Ctx.Provider value={{ user, loading, setUser, refresh, logout }}>{children}</Ctx.Provider>;
}
